"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HourlyYearPeriodizer = void 0;
const constants_1 = require("../../../../constants");
const sharedTypes_1 = require("../sharedTypes");
const DimensionedPeriodizer_1 = require("./DimensionedPeriodizer");
const util_1 = require("../../../../util");
const debug = util_1.DEBUG_OVERRIDE || (util_1.NOT_LAMBDA && false);
const className = 'HourlyYearPeriodizer';
/**
 * @class QuarterHourPeriodizer manages periodization for 1 month of quarter hour peridos
 */
class HourlyYearPeriodizer extends DimensionedPeriodizer_1.DimensionedPeriodizer {
    constructor(ob) {
        super(ob);
        this.timeBucketDefinition = {
            unit: util_1.TimeBucketUnits.HOUR,
            width: 1,
        };
        this.timeBucketToAccessor = (timeBucketAccessor) => {
            const [y, m, d, h, min, s] = timeBucketAccessor;
            const thisAccessor = [m, (d - 1), h];
            return thisAccessor;
        };
        this.periodizerDaysLength = () => (0, util_1.daysInLastUTCYear)(this.lastUpdatedTimestamp ?? 0);
        this.getFirstPossibleTimestamp = () => (this.lastUpdatedTimestamp ?? 0) - this.periodizerDaysLength() * constants_1.Milliseconds.DAY + 1 * constants_1.Milliseconds.HOUR;
        this.accessorToTimestamp = (accessor) => {
            const startTimestamp = this.lastUpdatedTimestamp ?? 0;
            const currentAccessor = this.timestampToAccessor(startTimestamp);
            const [_monthsDiff, daysDiff, hoursDiff] = accessor.map((v, i) => v - currentAccessor[i]);
            // handle rollover by when days same hour same quarter more, days same hour more, days more
            let absoluteNegativeDiff;
            const currentMonth = currentAccessor[0];
            const acccessorMonth = accessor[0];
            const monthDaysDiffRes = (0, util_1.monthDaysDiff)(acccessorMonth, currentMonth, this.lastUpdatedTimestamp ?? 0);
            const relativeDiff = monthDaysDiffRes * constants_1.Milliseconds.DAY + daysDiff * constants_1.Milliseconds.DAY + hoursDiff * constants_1.Milliseconds.HOUR;
            if (relativeDiff > 0) {
                // absolute diff A + B is length of bucket minus how far ahead the accessor is xxxxx  [<---A---xxxxx--B-->]
                absoluteNegativeDiff = -(this.periodizerDaysLength() * constants_1.Milliseconds.DAY - relativeDiff);
            }
            else {
                absoluteNegativeDiff = relativeDiff;
            }
            const impliedTimestamp = startTimestamp + absoluteNegativeDiff;
            // if ( accessor.every( ( v, i) => v === 0 ) ) { console.log({ accessor, currentAccessor, _monthsDiff, daysDiff, hoursDiff, monthDaysDiffRes, relativeDiff, impliedTimestamp, date: new Date(impliedTimestamp).toUTCString() }) }
            return impliedTimestamp;
        };
        this.isValidAccessor = (args) => {
            const date = new Date(this.lastUpdatedTimestamp ?? 0);
            const currentAccessor = this.timestampToAccessor(this.lastUpdatedTimestamp ?? 0);
            if (this.arrayLengths && (0, util_1.comparableProductOf)(args, this.arrayLengths) > (0, util_1.comparableProductOf)(currentAccessor, this.arrayLengths)) {
                // in year before, still possible that 31 30 may cause an issue
                date.setUTCFullYear(date.getUTCFullYear() - 1, args[0], 1);
            }
            else {
                date.setUTCMonth(args[0], 1);
            }
            const maxDays = (0, util_1.daysInThisUTCMonth)(date.valueOf());
            const isValid = args.length === this.arrayLengths?.length && args.every((d, i) => d >= 0 && d < (this.arrayLengths?.[i] ?? 0)) && args[1] <= maxDays - 1;
            if (!isValid) {
                debug && console.log(`Not valid accessor`, args);
            }
            debug && console.log({ accessor: args, maxDays, isValid, date: date.toUTCString() });
            return isValid;
        };
        if (!ob) {
            this.type = className;
            this.arrayLengths = sharedTypes_1.HourlyYearBasedArrayDef;
            this.initialize();
        }
    }
}
exports.HourlyYearPeriodizer = HourlyYearPeriodizer;
